import { Suspense, useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/app/redux/createAction';
import { CompanyPage } from 'src/pages/CompanyPage';
import { MainPage } from 'src/pages/MainPage';
import { ReportPageLazy } from 'src/pages/ReportPage';
import { GreetingsPage } from 'src/pages/SignInPage/GreetingsPage';
import { renderRoute } from '../lib/renderRoute';
import { ScrollToTop } from './ScrollToTop';
import { actionsUserInfo } from 'src/pages/MainPage/_BLL/slice';

export const routerPath = {
	mainPage: '/main',
	companyPage: '/company',
	reportPage: '/report',
};

export const AppRouter = () => {
	const userData = useAppSelector((state) => state.auth.userData);
	const dictionaries = useAppSelector((state) => state.metaDictionaries.dictionaries);

	// * Actions
	const dispatch = useAppDispatch();
	const { getCompanies } = actionsUserInfo;

	// * Initialization
	useEffect(() => {
		if (userData?.id) {
			dispatch(getCompanies());
		}
	}, [userData?.id]);

	const coreDataExists = dictionaries;
	const coreData = coreDataExists
		? {
				dictionaries,
			}
		: null;

	// * Conditions
	const userLoggedIn = userData && dictionaries;
	const userBasicAccess = userData?.accessRights.includes('CompanyOwnDataAccess');

	// * Render
	return (
		<BrowserRouter>
			<ScrollToTop />

			<Suspense fallback={<div>Loading...</div>}>
				<Routes>
					<Route
						path="/"
						element={
							userLoggedIn ? (
								<Navigate
									to={routerPath.mainPage}
									replace
								/>
							) : (
								<GreetingsPage />
							)
						}
					/>

					<Route
						path={routerPath.mainPage}
						element={
							userLoggedIn ? (
								<MainPage />
							) : (
								<Navigate
									to="/"
									replace
								/>
							)
						}
					/>

					{renderRoute({
						path: `${routerPath.companyPage}/:companyId`,
						coreData,
						PageComponent: <CompanyPage />,
						userData,
						permission: userBasicAccess,
					})}

					{renderRoute({
						path: `${routerPath.reportPage}`,
						coreData,
						PageComponent: <ReportPageLazy />,
						userData,
						permission: userBasicAccess,
					})}

					<Route
						path="*"
						element={<div>404</div>}
					/>
				</Routes>
			</Suspense>
		</BrowserRouter>
	);
};
